import axios from 'axios';
import { baseUrl, withAuth } from '../auth/helper';

export default {
  getNotifications: withAuth(async (params, options) => {
    const response = await axios.get(`${baseUrl}/notifications`, options)
    return response
  }),
}